import { render } from "./CartItemQty.vue?vue&type=template&id=c58a7f2c"
import script from "./CartItemQty.vue?vue&type=script&lang=js"
export * from "./CartItemQty.vue?vue&type=script&lang=js"

import exportComponent from "/builds/etos-b2b/b2b-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__